export default {
    'TOGGLE_LOADER': 'TOGGLE_LOADER',
}